export default {
  stripe: {
    stripePublishableKey:
      process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY ||
      "pk_test_1iSgIXXRw2BVyJTDklEb1xiB",
    stripeSecretKey:
      process.env.REACT_APP_STRIPE_SECRET_KEY ||
      "sk_test_7hf0NFtF4MuyrWTgtVRPnqXo",
  },
  firebase: {
    apiKey:
      process.env.REACT_APP_API_KEY ||
      "AIzaSyCSB2wN0m0TRANrHluPCTvl5jHbwnqzOBQ",
    authDomain:
      process.env.REACT_APP_AUTH_DOMAIN || "outro-app.firebaseapp.com",
    databaseURL:
      process.env.REACT_APP_DATABASE_URL || "https://outro-app.firebaseio.com",
    projectId: process.env.REACT_APP_PROJECT_ID || "outro-app",
    storageBucket:
      process.env.REACT_APP_STORAGE_BUCKET || "outro-app.appspot.com",
    messagingSenderId:
      process.env.REACT_APP_MESSAGING_SENDER_ID || "369469661135",
  },
  segment: {
    apiKey:
      process.env.REACT_APP_SEGMENT_API_KEY ||
      "mDu4eG5upUu7JyKJeagOZEOWFZZiLVH4",
  },
};



// WEBPACK FOOTER //
// ./src/config/index.js